import { render, staticRenderFns } from "./OurNetwork.vue?vue&type=template&id=8a3326fc&scoped=true"
import script from "./OurNetwork.vue?vue&type=script&setup=true&lang=js"
export * from "./OurNetwork.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OurNetwork.vue?vue&type=style&index=0&id=8a3326fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3326fc",
  null
  
)

export default component.exports